module.exports = __webpack_public_path__ + "9b38c62459e011db74ed14a6a3f77af7.ttf";